import React from 'react';
import R from 'ramda';
import { Loading, FilledButton, Exit, ActivateDialog } from '../app/components';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { updatePropertyWithImages } from '../../common/properties/actions';
import moment from 'moment';
import { mapZipToDetailLocation, mapType, getThousandSeperatedNumber } from '../../common/app/helperFunctions';
import Slider from 'react-slick';
import './styles.css';

moment.locale('is');

let GoogleMapLoader = null;
let GoogleMap = null;
let Marker = null;

class PropertyDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMap: false,
      fetchingDataDone: false,
      imagesLoaded: 0,
      confirmActivate: false,
      expandedImages: false,
      activeSlide: 0,
    };
  }

  componentWillMount = () => {
    GoogleMapLoader = require('react-google-maps').GoogleMapLoader;
    GoogleMap = require('react-google-maps').GoogleMap;
    Marker = require('react-google-maps').Marker;
  }

  componentDidMount = () => {
    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentDidUpdate = () => {
    const { propertyDetails } = this.props;
    const { fetchingDataDone } = this.state;

    if (propertyDetails !== undefined && !fetchingDataDone) {
      this.setState({
        fetchingDataDone: true,
      }, this.loadImages);
    }
  }

  componentWillUnmount = () => {
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown = (e) => {
    const { expandedImages } = this.state;
    if (expandedImages) {
      if (e.keyCode === 27) {
        this.setState({ expandedImages: false });
      } else if (e.keyCode === 39) {
        this.slider.slickNext();
      } else if (e.keyCode === 37) {
        this.slider.slickPrev();
      }
    }
  }

  toggleExpandedImages = (key) => {
    this.setState({ expandedImages: !this.state.expandedImages, activeSlide: key });
  }

  toggleShowMap = () => {
    this.setState({ showMap: !this.state.showMap });
  }

  loadImage = (url) => {
    const img = new Image();
    img.src = url.toString();
    img.onload = () => {
      this.setState({
        imagesLoaded: this.state.imagesLoaded + 1,
      });
    };
    img.src = url.toString();
  }

  loadImages = () => {
    const { propertyDetails } = this.props;

    for (let i = 0; i < propertyDetails.imageDownloadUrls.length; i += 1) {
      this.loadImage(propertyDetails.imageDownloadUrls[i].url);
    }
  }

  render() {
    const {
      location, propertyDetails, userDetails, viewer, updatePropertyWithImages,
    } = this.props;
    const {
      showMap, imagesLoaded, confirmActivate, expandedImages, activeSlide,
    } = this.state;

    return (
      <div>
        {imagesLoaded !== propertyDetails.imageDownloadUrls.length ?
          <Loading loading loadingColor="#00E39A" backgroundColor="#ffffff" />
        :
          expandedImages ?
            <div className="expanded-images" ref={node => (this.node = node)}>
              <button className="exit" onClick={() => this.toggleExpandedImages(0)}>
                <span className="icon-close-shadow" style={{ color: '#ffffff' }} />
              </button>
              <Slider
                ref={c => (this.slider = c)}
                infinite
                speed={800}
                initialSlide={activeSlide}
                nextArrow={
                  <img
                    role="presentation"
                    src="https://firebasestorage.googleapis.com/v0/b/rentimizer-e5308.appspot.com/o/white-next-arrow.png?alt=media&token=1b29e2c3-b4d7-4987-9dd1-0deec06a7fb1"
                  />
                }
                prevArrow={
                  <img
                    role="presentation"
                    src="https://firebasestorage.googleapis.com/v0/b/rentimizer-e5308.appspot.com/o/white-prev-arrow.png?alt=media&token=4da2985e-fc81-41cc-9632-7e92821e223c"
                  />
                }
              >
                {propertyDetails.imageDownloadUrls.map((imageDownloadUrl, key) =>
                  <button key={key} className="image" style={{ backgroundImage: `url(${imageDownloadUrl.url})` }} />,
                )}
              </Slider>
            </div>
          :
            <div className="property-details">
              <ActivateDialog
                component={this}
                propertyId={propertyDetails.id}
                confirmActivate={confirmActivate}
                updatePropertyWithImages={updatePropertyWithImages}
              />
              {GoogleMapLoader && GoogleMap && showMap ?
                <div className="map-wrapper">
                  <GoogleMapLoader
                    containerElement={<div className="google-maps-wrapper" />}
                    googleMapElement={
                      <GoogleMap
                        defaultZoom={15}
                        center={{ lat: propertyDetails.latitude, lng: propertyDetails.longitude }}
                        draggable
                        defaultOptions={{ disableDefaultUI: true }}
                      >
                        <Marker
                          onDragend={this.onDragend}
                          position={{
                            lat: propertyDetails.latitude, lng: propertyDetails.longitude,
                          }}
                          defaultAnimation={2}
                          icon="https://firebasestorage.googleapis.com/v0/b/rentimizer-e5308.appspot.com/o/google-maps-pin.png?alt=media&token=72361491-12f0-4210-8a37-8e4914c44b08"
                          cursor="pointer"
                          visible
                        />
                      </GoogleMap>
                    }
                  />
                  <div className="header-wrapper first-step">
                    <Exit to={location.state ? location.state.from : '/'} color="#ffffff" requireConfirm={false} />
                  </div>
                  <FilledButton
                    className="photos-button"
                    content={
                      <div>
                        <span className="icon-photos-icon" />
                        <p>Myndir</p>
                      </div>
                    }
                    disabled={false}
                    onClick={this.toggleShowMap}
                    color="#222222"
                    backgroundColor="#00e39a"
                    styles={{
                      position: 'absolute',
                      bottom: '20px',
                      right: '20px',
                    }}
                  />
                  <a
                    href={`http://maps.google.com/?q=${propertyDetails.latitude},${propertyDetails.longitude}`}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <FilledButton
                      content={
                        <p>Opna í Maps</p>
                      }
                      className="no-icon"
                      disabled={false}
                      color="#222222"
                      backgroundColor="#ffffff"
                      styles={{
                        position: 'absolute',
                        bottom: '20px',
                        left: '20px',
                      }}
                    />
                  </a>
                </div>
              :
                <div className="image-wrapper">
                  <Slider
                    infinite
                    speed={800}
                    initialSlide={activeSlide}
                    nextArrow={
                      <img
                        role="presentation"
                        src="https://firebasestorage.googleapis.com/v0/b/rentimizer-e5308.appspot.com/o/white-next-arrow.png?alt=media&token=1b29e2c3-b4d7-4987-9dd1-0deec06a7fb1"
                      />
                    }
                    prevArrow={
                      <img
                        role="presentation"
                        src="https://firebasestorage.googleapis.com/v0/b/rentimizer-e5308.appspot.com/o/white-prev-arrow.png?alt=media&token=4da2985e-fc81-41cc-9632-7e92821e223c"
                      />
                    }
                  >
                    {propertyDetails.imageDownloadUrls.map((imageDownloadUrl, key) =>
                      <button
                        key={key}
                        onClick={() => this.toggleExpandedImages(key)} className="image"
                        style={{ backgroundImage: `url(${imageDownloadUrl.url})` }}
                      />,
                    )}
                  </Slider>
                  <div className="header-wrapper first-step">
                    <Exit to={location.state ? location.state.from : '/'} color="#ffffff" requireConfirm={false} />
                  </div>
                  <FilledButton
                    className="maps-button"
                    content={
                      <div>
                        <span className="icon-map-icon" />
                        <p>Kort</p>
                      </div>
                    }
                    disabled={false}
                    onClick={this.toggleShowMap}
                    color="#222222"
                    backgroundColor="#00e39a"
                    styles={{
                      position: 'absolute',
                      bottom: '20px',
                      right: '20px',
                    }}
                  />
                </div>
              }
              {(viewer && viewer.id === propertyDetails.ownerId) &&
                <div>
                  {propertyDetails.active ?
                    <div className="status-bar active">
                      <p>Þessi auglýsing er virk</p>
                      <Link
                        to={{
                          pathname: `/editProperty/${propertyDetails.id}`,
                          state: { from: `/properties/${propertyDetails.id}`, prevFrom: location.state ? location.state.from : '/' },
                        }}
                      >
                        <FilledButton
                          className="no-icon"
                          content={
                            <div>Breyta eign</div>
                          }
                          disabled={false}
                          flat
                          color="#ffffff"
                          backgroundColor="transparent"
                        />
                      </Link>
                    </div>
                  :
                    <div className="status-bar inactive">
                      <p>Þessi auglýsing er óvirk</p>
                      <Link
                        to={{
                          pathname: `/editProperty/${propertyDetails.id}`,
                          state: { from: `/properties/${propertyDetails.id}`, prevFrom: location.state ? location.state.from : '/' },
                        }}
                      >
                        <FilledButton
                          className="no-icon"
                          content={
                            <div>Breyta eign</div>
                          }
                          disabled={false}
                          flat
                          color="#ffffff"
                          backgroundColor="transparent"
                        />
                      </Link>
                    </div>
                  }
                </div>
              }
              <div className="info-container">
                <div className="full-info">
                  <div className="info-box info">
                    <div className="address-wrapper">
                      <div className="address">{propertyDetails.address}</div>
                      <div className="price">{getThousandSeperatedNumber(propertyDetails.price)} <span>kr.</span></div>
                    </div>
                    <div className="title">{propertyDetails.title}</div>
                  </div>

                  <div className="info-box quick-info">
                    <div>
                      <div className="icon">
                        <span className="icon-location-icon" />
                        <p>{propertyDetails.zip}</p>
                      </div>
                      <div className="quick-info-description">{mapZipToDetailLocation(propertyDetails.zip)}</div>
                    </div>
                    <div>
                      <div className="icon">
                        {propertyDetails.type === 'house' &&
                          <span className="icon-house-icon-small" />
                        }
                        {propertyDetails.type === 'apartment' &&
                          <span className="icon-apt-icon-small" />
                        }
                        {propertyDetails.type === 'room' &&
                          <span className="icon-room-icon-small" />
                        }
                        {propertyDetails.type === 'commercial' &&
                          <span className="icon-commercial-icon-small" />
                        }
                      </div>
                      <div className="quick-info-description">{mapType(propertyDetails.type)}</div>
                    </div>
                    {propertyDetails.bedrooms !== 0 &&
                      <div>
                        <div className="icon">
                          <span className="icon-bedroom-icon" />
                          <span className="icon-x-icon" />
                          <p>{propertyDetails.bedrooms}</p>
                        </div>
                        <div className="quick-info-description">Svefnherbergi</div>
                      </div>
                    }
                    <div>
                      <div className="icon">
                        <span className="icon-size-icon" />
                        <p>{getThousandSeperatedNumber(propertyDetails.size)}</p>
                      </div>
                      <div className="quick-info-description">Fermetrar</div>
                    </div>
                  </div>

                  <div className="info-box">
                    <div className="description-title">Aðeins um íbúðina</div>
                    <div className="description">{propertyDetails.description}</div>
                  </div>

                  <div className="info-box dates-wrapper">
                    <div className="available-from-wrapper">
                      <div className="available-title">Laus frá</div>
                      <div className="available-date">
                        {moment().isBefore(propertyDetails.availableFrom) ?
                          moment(propertyDetails.availableFrom).format('D MMM YYYY') :
                          'Strax'
                        }
                      </div>
                    </div>
                    <div className="arrow-wrapper"><span className="icon-arrow" /></div>
                    <div className="available-to-wrapper">
                      <div className="available-title">Laus til</div>
                      <div className="available-date">{propertyDetails.availableTo ? moment(propertyDetails.availableTo).format('D MMM YYYY') : 'Langtímaleiga'}</div>
                    </div>
                  </div>

                  <div className="info-box insurance">
                    <div className="big-price-wrapper">Mánaðarleiga</div>
                    <div className="big-price">{getThousandSeperatedNumber(propertyDetails.price)} <span>kr.</span></div>
                    <div className="insurance-wrapper">
                      <div>
                        <div className="insurance-title">Upphæð tryggingar</div>
                        <div className="insurance-value">{getThousandSeperatedNumber(propertyDetails.insuranceAmount)} <span>kr.</span></div>
                      </div>
                      <div>
                        <div className="insurance-title">Tegund tryggingar</div>
                        <div className="insurance-value">{propertyDetails.insuranceType}</div>
                      </div>
                    </div>
                  </div>

                  <div className="info-box pros-cons-wrapper">
                    <div className="pros-wrapper">
                      <div className="pros-cons-title">Kostir</div>
                      {propertyDetails.electricityIncluded ? <div className="pros-cons-item pros-item"><p>Rafmagn innifalið</p><span className="icon-electricity-icon" /></div> : null}
                      {propertyDetails.heatIncluded ? <div className="pros-cons-item pros-item"><p>Hiti innifalinn</p><span className="icon-heat-icon" /></div> : null}
                      {propertyDetails.smokingAllowed ? <div className="pros-cons-item pros-item"><p>Reykingar leyfðar</p><span className="icon-smoking-icon" /></div> : null}
                      {propertyDetails.petsAllowed ? <div className="pros-cons-item pros-item"><p>Gæludýr leyfð</p><span className="icon-pets-icon" /></div> : null}
                      {propertyDetails.furnitureIncluded ? <div className="pros-cons-item pros-item"><p>Húsgögn fylgja</p><span className="icon-furniture-icon" /></div> : null}
                      {propertyDetails.fridgeIncluded ? <div className="pros-cons-item pros-item"><p>Ísskápur</p><span className="icon-fridge-icon" /></div> : null}
                      {propertyDetails.stoveIncluded ? <div className="pros-cons-item pros-item"><p>Eldavél</p><span className="icon-stove-icon" /></div> : null}
                      {propertyDetails.dishwasherIncluded ? <div className="pros-cons-item pros-item"><p>Uppþvottavél</p><span className="icon-dishwasher-icon" /></div> : null}
                      {propertyDetails.washingMachineIncluded ? <div className="pros-cons-item pros-item"><p>Þvottavél</p><span className="icon-washing-machine-icon" /></div> : null}
                      {propertyDetails.dryingMachineIncluded ? <div className="pros-cons-item pros-item"><p>Þurrkari</p><span className="icon-drying-machine-icon" /></div> : null}
                      {propertyDetails.showerIncluded ? <div className="pros-cons-item pros-item"><p>Sturta</p><span className="icon-shower-icon" /></div> : null}
                      {propertyDetails.bathIncluded ? <div className="pros-cons-item pros-item"><p>Baðkar</p><span className="icon-bath-icon" /></div> : null}
                    </div>
                    <div className="cons-wrapper">
                      <div className="pros-cons-title">Ókostir</div>
                      {!propertyDetails.electricityIncluded ? <div className="pros-cons-item cons-item"><p>Rafmagn innifalið</p><span className="icon-electricity-icon" /></div> : null}
                      {!propertyDetails.heatIncluded ? <div className="pros-cons-item cons-item"><p>Hiti innifalinn</p><span className="icon-heat-icon" /></div> : null}
                      {!propertyDetails.smokingAllowed ? <div className="pros-cons-item cons-item"><p>Reykingar leyfðar</p><span className="icon-smoking-icon" /></div> : null}
                      {!propertyDetails.petsAllowed ? <div className="pros-cons-item cons-item"><p>Gæludýr leyfð</p><span className="icon-pets-icon" /></div> : null}
                      {!propertyDetails.furnitureIncluded ? <div className="pros-cons-item cons-item"><p>Húsgögn fylgja</p><span className="icon-furniture-icon" /></div> : null}
                      {!propertyDetails.fridgeIncluded ? <div className="pros-cons-item cons-item"><p>Ísskápur</p><span className="icon-fridge-icon" /></div> : null}
                      {!propertyDetails.stoveIncluded ? <div className="pros-cons-item cons-item"><p>Eldavél</p><span className="icon-stove-icon" /></div> : null}
                      {!propertyDetails.dishwasherIncluded ? <div className="pros-cons-item cons-item"><p>Uppþvottavél</p><span className="icon-dishwasher-icon" /></div> : null}
                      {!propertyDetails.washingMachineIncluded ? <div className="pros-cons-item cons-item"><p>Þvottavél</p><span className="icon-washing-machine-icon" /></div> : null}
                      {!propertyDetails.dryingMachineIncluded ? <div className="pros-cons-item cons-item"><p>Þurrkari</p><span className="icon-drying-machine-icon" /></div> : null}
                      {!propertyDetails.showerIncluded ? <div className="pros-cons-item cons-item"><p>Sturta</p><span className="icon-shower-icon" /></div> : null}
                      {!propertyDetails.bathIncluded ? <div className="pros-cons-item cons-item"><p>Baðkar</p><span className="icon-bath-icon" /></div> : null}
                    </div>
                  </div>
                </div>

                <div className="info-card">
                  <div className="info-box">
                    <div className="big-price-wrapper">Mánaðarleiga</div>
                    <div className="big-price">{getThousandSeperatedNumber(propertyDetails.price)} <span>kr.</span></div>
                    <div className="insurance-title">Upphæð tryggingar</div>
                    <div className="insurance-value">{getThousandSeperatedNumber(propertyDetails.insuranceAmount)} <span>kr.</span></div>
                    <div className="insurance-title">Tegund tryggingar</div>
                    <div className="insurance-value">{propertyDetails.insuranceType}</div>
                  </div>

                  <div className="contact-info-card">
                    <img role="presentation" src={userDetails ? userDetails.photoURL : ''} width="30px" height="30px" />
                    <p>{userDetails ? userDetails.displayName : ''}</p>
                    <div className="contact-wrapper">
                      {propertyDetails.contactFacebook !== '' &&
                        <a href={`https://facebook.com/${propertyDetails.contactFacebook}`} rel="noopener noreferrer" target="_blank">
                          <FilledButton
                            content={<div><span className="icon-messenger-icon" /><p>Hafa samband</p></div>}
                            disabled={false}
                            color="#ffffff"
                            backgroundColor="#0084ff"
                          />
                        </a>
                      }
                      {propertyDetails.contactPhonenumber !== '' &&
                        <a href={`tel:+354${propertyDetails.contactPhonenumber}`}>
                          <FilledButton
                            content={<div><span className="icon-phone" /><p>{propertyDetails.contactPhonenumber}</p></div>}
                            disabled={false}
                            color="#ffffff"
                            backgroundColor="#222222"
                          />
                        </a>
                      }
                      {propertyDetails.contactEmail !== '' &&
                        <a href={`mailto:${propertyDetails.contactEmail}`}>
                          <FilledButton
                            content={<div><span className="icon-email-icon" /><p>{propertyDetails.contactEmail}</p></div>}
                            disabled={false}
                            color="#ffffff"
                            backgroundColor="#222222"
                          />
                        </a>
                      }
                    </div>
                  </div>
                </div>
              </div>

              <div className="contact-info">
                <div className="user-wrapper">
                  <img role="presentation" src={userDetails ? userDetails.photoURL : ''} width="30px" height="30px" />
                  <p>{userDetails ? userDetails.displayName : ''}</p>
                </div>
                <div className="contact-wrapper">
                  {propertyDetails.contactFacebook !== '' &&
                    <a href={`https://www.facebook.com/${propertyDetails.contactFacebook}`} rel="noopener noreferrer" target="_blank">
                      <FilledButton
                        content={<div><span className="icon-messenger-icon" /><p>Hafa samband</p></div>}
                        disabled={false}
                        color="#ffffff"
                        backgroundColor="#0084ff"
                      />
                    </a>
                  }
                  {propertyDetails.contactPhonenumber !== '' &&
                    <a href={`tel:+354${propertyDetails.contactPhonenumber}`}>
                      <FilledButton
                        content={<div><span className="icon-phone" /><p>{propertyDetails.contactPhonenumber}</p></div>}
                        disabled={false}
                        color="#ffffff"
                        backgroundColor="#222222"
                      />
                    </a>
                  }
                  {propertyDetails.contactEmail !== '' &&
                    <a href={`mailto:${propertyDetails.contactEmail}`}>
                      <FilledButton
                        className="email-button"
                        content={<div><span className="icon-email-icon" /><p>{propertyDetails.contactEmail}</p></div>}
                        disabled={false}
                        color="#ffffff"
                        backgroundColor="#222222"
                      />
                    </a>
                  }
                </div>
              </div>
            </div>
        }
      </div>
    );
  }
}

PropertyDetails.propTypes = {
  location: React.PropTypes.any,
  propertyDetails: React.PropTypes.object.isRequired,
  userDetails: React.PropTypes.object,
  viewer: React.PropTypes.object,
  updatePropertyWithImages: React.PropTypes.func.isRequired,
};

export default R.compose(
  connect(
    state => ({
      viewer: state.users.viewer,
    }),
    { updatePropertyWithImages },
  ),
)(PropertyDetails);



// WEBPACK FOOTER //
// ./src/browser/propertyDetails/PropertyDetails.js